export const longPress = {
  mounted(el, binding) {
    let timer = null;
    let isPressed = false;  // 添加状态标记

    if (typeof binding.value !== 'function') {
      return
    }

    let pressTimer = null;
    const start = (e) => {
      if (e.type === 'click' && e.button !== 0) {
        return
      }

      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          handler()
        }, 1000) // 500ms后触发
      }
    }

    const cancel = () => {
      if (pressTimer !== null) {
        clearTimeout(pressTimer)
        pressTimer = null
      }
    }

    const handler = (e) => {
      binding.value(e)
    }

    // 添加事件监听器
    el.addEventListener('mousedown', start)
    // 取消计时器
    el.addEventListener('touchstart', (e) => {
      if (isPressed) return;  // 如果已经在处理中，直接返回
      isPressed = true;
      
      timer = setTimeout(() => {
        binding.value(e);
        isPressed = false;  // 重置状态
      }, 1000);
    });
    
    el.addEventListener('touchend', () => {
      clearTimeout(timer);
      isPressed = false;  // 重置状态
    });
    
    el.addEventListener('touchcancel', () => {
      clearTimeout(timer);
      isPressed = false;  // 重置状态
    });
    el.addEventListener('click', cancel)
    el.addEventListener('mouseout', cancel)
  }
}